import { sendOrvestoStatistics, trackViewEvent } from 'app/utils/statistics/clientStatistics';
import React from 'react';

class SendStatistics extends React.Component {
    constructor(props) {
        super(props);

        const { statisticsObject } = this.props;

        if (statisticsObject && typeof window !== 'undefined') {
            statisticsObject.orvestoData && sendOrvestoStatistics(statisticsObject.orvestoData);
            statisticsObject.dataLake && trackViewEvent(statisticsObject.dataLake);
        }
    }

    render() {
        return null;
    }
}

export default SendStatistics;
